import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionKey } from '../models';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateFn = async (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const required = route.data['permissions'] as PermissionKey[] | undefined;
  if (!required || required.length === 0) {
    return true;
  }

  await permissionService.ensureInitialized();

  if (permissionService.hasAnyPermission(required)) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
